var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#fa5c0e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-40 359.33-160.67H186.67q-27 0-46.84-19.83Q120-200.33 120-227.33V-814q0-27.5 19.83-47.08 19.84-19.59 46.84-19.59h586.66q27 0 46.84 19.59Q840-841.5 840-814v586.67q0 27-19.83 46.83-19.84 19.83-46.84 19.83H600.67L480-40ZM186.67-267.33q58-55 132.43-88.17t160.83-33.17q86.4 0 160.9 33.17t132.5 88.17V-814H186.67v546.67ZM481.33-468q58 0 98.34-40.33Q620-548.67 620-606.67T579.67-705q-40.34-40.33-98.34-40.33T383-705q-40.33 40.33-40.33 98.33T383-508.33Q423.33-468 481.33-468ZM250-227.33h460v-9.34Q660-279 601.67-300.5 543.33-322 480-322t-121.67 21.5Q300-279 250-236.67v9.34Zm231.33-307.34q-30 0-51-21t-21-51q0-30 21-51t51-21q30 0 51 21t21 51q0 30-21 51t-51 21ZM480-541Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.f43a8486385a9ef84c88469152ac8b6d.svg";
export { ForwardRef as ReactComponent };